module.exports = __webpack_public_path__ + "img/remove_24px.3ed8a230.svg";